import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { throttle } from "lodash";

import DesktopHeader from "./desktop";
import MobileHeader from "./mobile";
import StickyBanner from "../../molecules/sticky-banner";

import { setMakeSecondaryApiCallsTriggered } from "../../store/actions";

// Common wrapper for navigation. We could add OffcanvasMenu, Navbar etc components here.

const Header = () => {
  const dispatch = useDispatch();
  const makeSecondaryApiCallsDelay = 1500;
  const [makeSecondaryApiCalls, setMakeSecondaryApiCalls] = useState(false);
  const [isMobile, setMobile] = useState(true);

  const getScroll = () => {
    if (typeof window !== "undefined") {
      if (window.scrollY > 700) {
        !makeSecondaryApiCalls && setMakeSecondaryApiCalls(true);
      }
    }
  };

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
      setMakeSecondaryApiCalls(true);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", throttle(getScroll, 250));
    return () => window.removeEventListener("scroll", getScroll);
  }, []);

  useEffect(() => {
    makeSecondaryApiCalls &&
      dispatch(setMakeSecondaryApiCallsTriggered(makeSecondaryApiCalls, makeSecondaryApiCallsDelay, isMobile));
  }, [makeSecondaryApiCalls]);

  return (
    <>
      <div className="hide-mobile">
        <DesktopHeader />
      </div>
      <div className="hide-desktop">
        <MobileHeader />
      </div>

      <StickyBanner />
    </>
  );
};

export { Header };
